import type { DifficultyConfig, Difficulty } from "./types";

export const difficulties: DifficultyConfig[] = [
  {
    id: "easy",
    name: "Easy",
    description: "Direct application of a known formula or concept",
    reasoning: "Single-step problems requiring recall and direct application of one concept or formula",
  },
  {
    id: "medium",
    name: "Medium",
    description: "Requires multiple steps or combining concepts",
    reasoning: "Multi-step problems requiring synthesis of 2-3 concepts or application of a concept in a non-routine way",
  },
  {
    id: "hard",
    name: "Hard",
    description: "Requires non-obvious reasoning, manipulation, or multiple mathematical concepts",
    reasoning: "Complex problems requiring creative problem-solving, multiple concept integration, or non-standard approaches",
  },
  {
    id: "expert",
    name: "Expert",
    description: "Requires substantial mathematical reasoning, proof construction, abstraction, or advanced techniques",
    reasoning: "Research-level or competition-level problems requiring deep understanding, proof writing, or advanced mathematical machinery",
  },
];

export function getDifficulty(id: Difficulty): DifficultyConfig | undefined {
  return difficulties.find((d) => d.id === id);
}

export function getDifficultyNames(): { id: Difficulty; name: string; description: string }[] {
  return difficulties.map((d) => ({ id: d.id, name: d.name, description: d.description }));
}